export default "/Heunginjimun.glb";